<template>
  <div class="tgmag-spacer" :style="styleRules" />
</template>

<script>
export default {
  name: "TransfersSpacer",
  props: {
    spacing: {
      type: Number,
      default: 5
    }
  },
  computed: {
    styleRules() {
      return {
        paddingBottom: `${this.spacing}px`
      };
    }
  }
};
</script>

<style scoped>
.tgmag-spacer {
  display: block;
}
</style>
